import { RewardsQueryParams } from '@adminServices';
import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import * as RewardsActions from './rewards.actions';
import * as RewardsSelectors from './rewards.selectors';

@Injectable({
  providedIn: 'root',
})
export class RewardsFacade {
  private store = inject(Store);

  rewards$ = this.store.select(RewardsSelectors.selectAllRewards);
  loading$ = this.store.select(RewardsSelectors.selectRewardsLoading);
  error$ = this.store.select(RewardsSelectors.selectRewardsError);
  pagination$ = this.store.select(RewardsSelectors.selectRewardsPagination);

  rewards = toSignal(this.rewards$, { initialValue: [] });
  loading = toSignal(this.loading$, { initialValue: false });

  loadRewards(params?: RewardsQueryParams): void {
    this.store.dispatch(RewardsActions.loadRewards({ params }));
  }

  createReward(rewardData: RewardsActions.CreateRewardData): void {
    this.store.dispatch(RewardsActions.createReward({ rewardData }));
  }

  updateReward(id: string, rewardData: RewardsActions.UpdateRewardData): void {
    this.store.dispatch(RewardsActions.updateReward({ id, rewardData }));
  }

  deleteReward(id: string): void {
    this.store.dispatch(RewardsActions.deleteReward({ id }));
  }
}
